import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './orderSummary.css';
import { updateOrderSummary, toggleTaxes } from '../../../store/checkoutSlice';
import { selectSubtotal } from '../../../store/selectors/checkoutSelectors';

const formatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  minimumFractionDigits: 0,
});


const OrderSummary = ({ setIsSummaryValid }) => {
  const dispatch = useDispatch();

  const subtotal = useSelector(selectSubtotal);
  const taxesEnabled = useSelector((state) => state.checkout.taxesEnabled);
  const orderSummary = useSelector((state) => state.checkout.orderSummary);

  useEffect(() => {
    dispatch(updateOrderSummary(subtotal, { skipTaxes: true }));
    setIsSummaryValid(false); // 🚨 Estado inicial falso
  }, [subtotal, dispatch, setIsSummaryValid]);

  const handleEnableTaxes = () => {
    dispatch(toggleTaxes(true));
    dispatch(updateOrderSummary(subtotal, { skipTaxes: false }));
    setIsSummaryValid(true); // ✅ Ahora es válido
  };

  const handleDisableTaxes = () => {
    dispatch(toggleTaxes(false));
    dispatch(updateOrderSummary(subtotal, { skipTaxes: true }));
    setIsSummaryValid(true); // ✅ Ahora es válido
  };

  const displayTaxes =
    taxesEnabled === null || orderSummary.taxes == null
      ? '--'
      : formatter.format(orderSummary.taxes);


  return (
    <div className="container mt-4">
      <div className="card shadow-sm order-summary-card">
        <div className="card-header bg-dark text-white">
          <h4 className="mb-0 text-center">Resumen de la Orden</h4>
        </div>
        <ul className="list-group list-group-flush">
          <li className="list-group-item d-flex justify-content-between align-items-center">
            Subtotal
            <span>{formatter.format(orderSummary.subtotal)}</span>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            Envío
            <span>{formatter.format(orderSummary.shipping)}</span>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            Impuestos
            <span>{displayTaxes}</span>
          </li>
          <li className="list-group-item d-flex justify-content-between align-items-center fw-bold fs-5 text-primary">
            Total
            <span>{formatter.format(orderSummary.total)}</span>
          </li>
        </ul>


        <div className="card-body text-center">
          {taxesEnabled === null && (
            <div className="mt-3 alert alert-warning" role="alert">
              Por favor elige si deseas factura para continuar.
            </div>
          )}

          <p className="mb-2 fw-semibold">¿Deseas factura electrónica?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-success" onClick={handleEnableTaxes}>
              Sí, con factura electrónica
            </button>
            <button className="btn btn-danger" onClick={handleDisableTaxes}>
              No, sin factura
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
